import DataLayer from '../Models/DataLayer';
import Item from '../Models/Item';

class AnalyticsEvent {
  /**
   * @public
   * @type {Item}
   */
  item;

  /**
   * @public
   * @type {DataLayer}
   */
  dataLayer;

  /**
   * @public
   * @type {RootStore} MST model
   */
  rootStore;

  /**
   * @param {Item} item
   * @param {DataLayer} dataLayer
   * @param {RootStore} rootStore
   */
  constructor(item, dataLayer, rootStore) {
    this.item = item;
    this.dataLayer = dataLayer;
    this.rootStore = rootStore;
  }
}

export default AnalyticsEvent;
